import __i18n from "../intl/__i18n";


export const enum ClientPlatform {
  "None"       = "none",
  "Web"       = "web",
  "Android"   = "android",
  "iOS"       = "i_os",
  "AndroidTv" = "android_tv",
  "WebTv" = "web_tv",
}


export const ClientPlatformOptions = [{
  value : ClientPlatform.None,
  label : __i18n("Not Specified")
},{
  value : ClientPlatform.Web,
  label : __i18n("Web")
}, {
  value : ClientPlatform.Android,
    label : __i18n("Android")
},{
  value : ClientPlatform.iOS,
    label : __i18n("iOS")
},{
  value : ClientPlatform.AndroidTv,
    label : __i18n("Android Tv")
}];
